import { createSelector } from 'reselect';
import { TApplicationState } from '../libs/store';

/*
 * replaysManagement:
 */

const replaysManagementState = (st: TApplicationState) => st?.replaysManagement;

export const isLoadingSelector = createSelector(replaysManagementState, (state) => state?.isLoading);

export const loadingKeystoneRunIdSelector = createSelector(replaysManagementState, (state) => state?.loadingKeystoneRunId);

export const replayListSelector = createSelector(replaysManagementState, (state) => state?.replayList);

export const replayListFetchStatusSelector = createSelector(replayListSelector, (replayList) => replayList?.fetchStatus);

export const replaysOptionsSelector = createSelector(replaysManagementState, (state) => state?.replaysOptions);

export const selectedRegionSelector = (state: TApplicationState) => {
	const foundRegionUS = state.auth?.bnet_linked_regions.find((region: string) => region === 'us');
	return state?.replaysManagement?.selectedRegion || foundRegionUS || state.auth?.bnet_linked_regions[0] || 'us'
}

export const errorSelector = createSelector(replaysManagementState, (state) => state?.error);
